module.exports = __webpack_public_path__ + "media/src/images/icons/reward/stars-3bbc0b2104464012a3a9b4ab830731b5.svg";